import ky from 'ky-universal'
import qs from 'qs'
import HttpBase from './base'

const handleResponseError = (error, definedHandlers) => {
  const { response } = error
  if (response.status && definedHandlers[response.status]) {
    definedHandlers[response.status](error.message, error)
  } else {
    definedHandlers.default(error.message, error)
  }
  return error
}

const defaultConfig = {
  // throwHttpErrors: false,
  parseJson(res) {
    try {
      return JSON.parse(res)
    } catch (e) {
      console.error('[解析请求的 JSON 出错]', res)
      return null
    }
  },
  timeout: 180000,
  hooks: {
    // beforeRequest: [
    //   (request) => {
    //     console.log('请求:', request)
    //   },
    // ],
    // afterResponse: [
    //   (request, options, response) => {
    //     console.log(options, 'options')
    //     if (response.status === 401) {
    //       console.log('token失效')
    //     }
    //     // return response.json()
    //   },
    // ],
    beforeError: [
      async (error) => {
        const { response } = error
        if (response && response.body) {
          const data = await response.json()
          error.message = `${data.message || data.msg}`
        }
        return error
      },
    ],
  },
}

export function setDefaultConfig(config) {
  Object.assign(defaultConfig, config)
}

export default class Ky extends HttpBase {
  get http() {
    if (this._ky) {
      return this._ky
    }
    // 注入接口错误处理方法
    defaultConfig.hooks.beforeError.push((error) =>
      handleResponseError(error, this.errorCallback)
    )
    this._ky = ky.create(defaultConfig).extend(this.config)
    return this._ky
  }
  ensureToken(
    originUrl,
    config = {
      searchParams: {},
      ignoreAuthorization: false,
      tokenField: null,
      token: null,
    }
  ) {
    const [path, search] = originUrl.split('?')
    const tokenField = config.tokenField || 'token'
    const searchParams = {
      [tokenField]:
        config.token ||
        this.getToken() ||
        (process.env.TARO_ENV === 'h5' && window.voltaliStoreToken),
      ...qs.parse(search),
      ...config.searchParams,
    }

    if (config.ignoreAuthorization) {
      delete searchParams[tokenField]
    }

    return {
      ...config,
      url: path,
      searchParams,
    }
  }

  request(url, config) {
    const extendedConfig = this.ensureToken(url, config)
    return this.http(url, extendedConfig)
  }

  head(url, config) {
    const extendedConfig = this.ensureToken(url, config)
    return this.http.head(url, extendedConfig)
  }

  get(url, config) {
    const extendedConfig = this.ensureToken(url, config)
    return this.http.get(url, extendedConfig)
  }

  delete(url, data, config) {
    const extendedConfig = this.ensureToken(url, config)
    return this.http.delete(url, { ...extendedConfig, json: data })
  }

  post(url, data, config) {
    const extendedConfig = this.ensureToken(url, config)
    if (data) {
      return this.http.post(url, { ...extendedConfig, json: data })
    }
    return this.http.post(url, extendedConfig)
  }

  put(url, data, config) {
    const extendedConfig = this.ensureToken(url, config)
    if (data) {
      return this.http.put(url, { ...extendedConfig, json: data })
    }
    return this.http.put(url, extendedConfig)
  }

  patch(url, data, config) {
    const extendedConfig = this.ensureToken(url, config)
    return this.http.patch(url, { ...extendedConfig, json: data })
  }
}
